import React from 'react'
import { isMobile } from 'react-device-detect'
import { SidebarGraph } from '@/store/sidebar'
import styled from 'styled-components'
import { ZIndexRange } from '@/types/style'
import { useLocationEffect } from '@/utils/hooks'
import { SidebarNav, SidebarTop } from '.'
import { useIsTabletSize } from '../../utils/hooks/useIsTabletSize'

const Wrapper = styled.div`
  position: relative;
  z-index: ${ZIndexRange.Sidebar};
  width: 100%;
  min-height: 100vh;
  padding: 1.4em;

  background: white;

  ${props => props.theme.layout.mobile} {
    position: absolute;
    left: 0;
    top: ${props => props.theme.layout.headerHeightMobile};
    width: 100%;
    overflow: auto;

    background: white;
    box-shadow: inset 0 4px 24px -8px #00000012;
  }

  ${props => props.theme.layout.largePad} {
    position: absolute;
    left: 0;
    top: ${props => props.theme.layout.headerHeightMobile};
    width: 100%;
    overflow: auto;

    background: white;
    box-shadow: inset 0 4px 24px -8px #00000012;
  }
`

export const Sidebar: React.FC = () => {
  const [{ open, toggle }] = SidebarGraph.useGraph()
  const { isTablet } = useIsTabletSize()
  const isMobileView = isMobile || isTablet

  useLocationEffect((_, type) => {
    if (type === 'PUSH') toggle(false)
  }, isMobile)

  if (!isMobileView)
    return (
      <Wrapper>
        <SidebarTop />
        <SidebarNav />
      </Wrapper>
    )

  if (!open) return null

  return (
    <Wrapper>
      <SidebarNav />
    </Wrapper>
  )
}
